export const setTracerUser = (tracer, identity) => {
    tracer.setUser({
        id: identity.unique_identity,
        email: identity.email_address,
        company_id: String(identity.company_id),
        company_name: identity.company_name,
        user_id: String(identity.user_id),
        user_name: identity.user_name,
    });
};
//# sourceMappingURL=setTracerUser.js.map